export default "__VITE_ASSET__B_EL_PW$__"